import React from "react";
import { Link } from "react-router-dom";

export default function Integration() {
  const credentialKerjasamaBu = JSON.parse(
    localStorage.getItem("kerjasama_bu")
  );
  const credentialPendapatanLainLain = JSON.parse(
    localStorage.getItem("pendapatan_lain_lain")
  );
  const credentialKpuUso = JSON.parse(localStorage.getItem("kpu_uso"));
  const credentialBank = JSON.parse(localStorage.getItem("jasa_perbankan"));
  const credentialCloudPendapatan = localStorage.getItem("client_id");
  const cloudPendapatanHost = process.env.REACT_APP_HOST_CLOUD_PENDAPATAN;
  const loggedinEmail = credentialKerjasamaBu.email;
  const allowedEmailTransaksiKeuangan =
    process.env.REACT_APP_ALLOWED_EMAIL_TRANSAKSI_KEUANGAN.split(",") || [];

  let integrations = [
    {
      name: "KPU/USO",
      id: "kpu-uso",
      "content-class":
        "flex flex-wrap w-full rounded-lg shadow-md md:max-w-sm bg-white content-center p-3 text-black hover:text-white hover:bg-kpu-uso-integration-hover duration-300",
      "url-app": credentialKpuUso
        ? credentialKpuUso["link"]
        : "https://kpu-uso.baktikominfo.id",
      "url-icon": "assets/images/integrations/kpu-uso.png",
      "url-icon-hover": "assets/images/integrations/kpu-uso-hover.png",
    },
    {
      name: "Perbankan",
      id: "jasaperbankan",
      "content-class":
        "flex flex-wrap w-full rounded-lg shadow-md md:max-w-sm bg-white content-center p-3 text-black hover:text-white hover:bg-perbankan-integration-hover duration-300",
      "url-app": credentialBank
        ? credentialBank["link"]
        : "https://epnbp.baktikominfo.id/bank",
      "url-icon": "assets/images/integrations/jasaperbankan.png",
      "url-icon-hover": "assets/images/integrations/jasaperbankan-hover.png",
    },
    {
      name: "Kerjasama BU",
      id: "kerjasamabu",
      "content-class":
        "flex flex-wrap w-full rounded-lg shadow-md md:max-w-sm bg-white content-center p-3 text-black hover:text-white hover:bg-kerjasama-bu-integration-hover duration-300",
      "url-app": credentialKerjasamaBu["link"],
      "url-icon": "assets/images/integrations/kerjasamabu.png",
      "url-icon-hover": "assets/images/integrations/kerjasamabu-hover.png",
    },
    {
      name: "Pendapatan Lain-lain",
      id: "pendapatanlainlain",
      "content-class":
        "flex flex-wrap w-full rounded-lg shadow-md md:max-w-sm bg-white content-center p-3 text-black hover:text-white hover:bg-lain-lain-integration-hover duration-300",
      "url-app": credentialPendapatanLainLain
        ? credentialPendapatanLainLain["link"]
        : "https://epnbp.baktikominfo.id/pendapatanlainlain",
      "url-icon": "assets/images/integrations/pendapatanlainlain.png",
      "url-icon-hover":
        "assets/images/integrations/pendapatanlainlain-hover.png",
    },
    {
      name: "Cloud Pendapatan",
      id: "cloudpendapatan",
      "content-class":
        "flex flex-wrap w-full rounded-lg shadow-md md:max-w-sm bg-white content-center p-3 text-black hover:text-white hover:bg-indigo-500 duration-300",
      "url-app": credentialCloudPendapatan
        ? cloudPendapatanHost + "?session=" + credentialCloudPendapatan
        : "https://epnbp.baktikominfo.id/pendapatanlainlain",
      "url-icon": "assets/images/integrations/cloud-pendapatan.png",
      "url-icon-hover": "assets/images/integrations/cloud-pendapatan-hover.png",
    },
  ];

  // Check apakah email yang sedang login merupakan email yang diperbolehkan untuk masuk ke transaksi keuangan
  if (allowedEmailTransaksiKeuangan.includes(loggedinEmail)) {
    integrations.push({
      name: "Transaksi Keuangan",
      id: "transaksikeuangan",
      "content-class":
        "flex flex-wrap w-full rounded-lg shadow-md md:max-w-sm bg-white content-center p-3 text-black hover:text-white hover:bg-orange-600 duration-300",
      "url-app": "transaksi-keuangan",
      "url-icon": "assets/images/integrations/transaksi-keuangan.png",
      "url-icon-hover":
        "assets/images/integrations/transaksi-keuangan-hover.png",
    });
  }

  const onMouseEnter = (event) => {
    let divId = event.currentTarget.id;
    let hoverImgUrl = integrations.find(
      (integration) => integration.id === divId
    )["url-icon-hover"];

    // Set Img on Hover
    event.currentTarget.querySelector("img").src =
      window.location.origin + process.env.REACT_APP_BASE_PATH + hoverImgUrl;
  };
  const onMouseLeave = (event) => {
    let divId = event.currentTarget.id;
    let unHoverImgUrl = integrations.find(
      (integration) => integration.id === divId
    )["url-icon"];

    // Set Img on Hover
    event.currentTarget.querySelector("img").src =
      window.location.origin + process.env.REACT_APP_BASE_PATH + unHoverImgUrl;
  };

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
        {integrations.map((val) => {
          return val["id"] !== "transaksikeuangan" ? (
            <a
              href={val["url-app"]}
              id={val["id"]}
              onMouseEnter={onMouseEnter}
              onMouseLeave={onMouseLeave}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div id={val["id"]} className={val["content-class"]}>
                <img
                  src={
                    window.location.origin +
                    process.env.REACT_APP_BASE_PATH +
                    val["url-icon"]
                  }
                  alt="icon"
                  className="object-scale-down h-16"
                />
                <h3 className="flex items-center justify-center ml-3 text-lg font-bold">
                  {val.name}
                </h3>
              </div>
            </a>
          ) : (
            <Link
              to={val["url-app"]}
              id={val["id"]}
              className={val["content-class"]}
              onMouseEnter={onMouseEnter}
              onMouseLeave={onMouseLeave}
            >
              <img
                src={
                  window.location.origin +
                  process.env.REACT_APP_BASE_PATH +
                  val["url-icon"]
                }
                alt="icon"
                className="object-scale-down h-16"
              />
              <h3 className="flex items-center justify-center ml-3 text-lg font-bold">
                {val.name}
              </h3>
            </Link>
          );
        })}
      </div>
    </>
  );
}
